// extracted by mini-css-extract-plugin
export default {"panel":"QueryErrorPanel_panel__Qo9Wa","message":"QueryErrorPanel_message__IqkRY"};